import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CogIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Cog",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.26 21.57c-3.15 0-5.71-2.56-5.71-5.71 0-1.01.27-2 .77-2.86.32-.55 1.02-.73 1.56-.42.55.32.73 1.02.42 1.56a3.434 3.434 0 0 0 2.97 5.15c1.89 0 3.43-1.54 3.43-3.43s-1.54-3.43-3.43-3.43a1.14 1.14 0 1 1 0-2.28c3.15 0 5.71 2.56 5.71 5.71s-2.56 5.71-5.71 5.71Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.89 31.86h-1.27c-1.48 0-2.79-.94-3.25-2.35l-.44-1.34c-.09-.27-.27-.49-.51-.63l-2.9-1.68c-.22-.13-.49-.18-.74-.14l-1.34.2c-1.31.19-2.62-.39-3.36-1.49l-.64-.96a3.41 3.41 0 0 1 0-3.8l1.06-1.58c.12-.19.19-.41.19-.63v-3.19c0-.23-.07-.44-.19-.63l-1.06-1.58a3.41 3.41 0 0 1 0-3.8l.64-.95a3.45 3.45 0 0 1 3.36-1.49l1.34.2c.25.04.52-.01.74-.14l2.94-1.71c.23-.13.4-.34.5-.59l.56-1.48c.5-1.33 1.79-2.22 3.21-2.22h1.08c1.42 0 2.71.89 3.21 2.22l.55 1.48c.09.25.27.46.5.59l2.94 1.71c.22.13.49.18.74.14l1.34-.2a3.45 3.45 0 0 1 3.36 1.49l.6.9c.79 1.19.76 2.76-.08 3.91l-.99 1.36c-.12.19-.18.41-.18.63l.02 3.36c0 .22.07.44.19.63l1.06 1.59c.77 1.16.77 2.65 0 3.8l-.64.95a3.45 3.45 0 0 1-3.36 1.49l-1.34-.2c-.25-.04-.52.01-.74.14l-2.9 1.68c-.24.14-.42.36-.51.63l-.44 1.33a3.42 3.42 0 0 1-3.25 2.35m-8.96-8.44c.6 0 1.2.16 1.73.46l2.9 1.68c.73.42 1.27 1.09 1.53 1.89l.44 1.34c.16.47.59.78 1.08.78h1.27c.49 0 .93-.32 1.08-.78l.44-1.34c.27-.8.81-1.47 1.53-1.89l2.9-1.68c.67-.39 1.46-.54 2.23-.43l1.34.2c.44.07.87-.13 1.12-.5l.64-.95c.26-.38.26-.88 0-1.27l-1.06-1.59c-.37-.56-.57-1.21-.58-1.88l-.02-3.36c0-.72.23-1.45.65-2.03l.95-1.31c.28-.38.29-.91.03-1.3l-.6-.9c-.24-.37-.68-.57-1.12-.5l-1.34.2c-.76.11-1.55-.04-2.23-.43l-2.95-1.71a3.44 3.44 0 0 1-1.49-1.76l-.56-1.48c-.17-.44-.6-.74-1.07-.74h-1.08c-.47 0-.9.3-1.07.74l-.56 1.48c-.28.74-.81 1.37-1.49 1.76L9.63 7.83c-.67.39-1.46.54-2.23.43l-1.34-.2c-.44-.07-.88.13-1.12.5l-.64.95c-.26.38-.26.88 0 1.27l1.06 1.58c.38.57.58 1.23.58 1.9v3.19c0 .68-.2 1.33-.58 1.9L4.3 20.94c-.26.39-.26.88 0 1.27l.64.95c.24.37.69.57 1.12.5l1.34-.2c.17-.02.33-.04.5-.04Z"
    })]
  }));
};
CogIcon.displayName = 'CogIcon';